import { UploadedMethodType } from '../../../../../store/onboardingStore';

export type MethodType = 'link' | 'manual' | 'previous';

export interface UpsellProduct {
  id: string;
  productName: string;
  price: string;
  description: string;
  image?: string;
  url_images?: string[];
  isManualEntry: boolean;
  productLink: string;
  externalId?: string | null;
  providerId?: string | null;
  isLoading?: boolean;
  error?: string;
  uploadedMethod?: UploadedMethodType;
}

export interface BumpOfferState {
  enabled: boolean;
  productName: string;
  price: string;
  description: string;
  image?: string;
  isManualEntry: boolean;
  productLink: string;
  externalId: string | null;
  providerId: string | null;
  url_images?: string;
  isLoading: boolean;
  error: string;
  uploadedMethod: UploadedMethodType;
}

export const createEmptyUpsell = (): UpsellProduct => ({
  id: Date.now().toString(),
  productName: '',
  price: '0.00',
  description: '',
  image: undefined,
  url_images: undefined,
  isManualEntry: false,
  productLink: '',
  externalId: null,
  providerId: null,
  isLoading: false,
  error: '',
});
